import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    Box,
    Button,
    AppBar,
    Toolbar,
    Grid,
    Typography,
    Modal,
    LinearProgress,
    TextField,
    Tooltip,
    CircularProgress
} from '@mui/material';
import HeaderAvatar from "./HeaderAvatar";
import {
    addScaenario, addVisit, deleteVisit, fetchPresentation,
    updatePresentation, updateScenario, fetchPresentations, updateVisit, getVisits
    // addVisit,
    // addSlideToVisit,
    // createVideoFolder,
    // getVisits,
    // getSlides,
    // processProject,
    // editVisitName,
    // reorderVisitSlides,
    // updateSlide, fetchProjects, deleteVisit
} from '../services/api';
import Icon from "./Icon";
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DragEndEvent } from '@dnd-kit/core';
import VisitBox from '../components/VisitBox';
// import { deleteVisitSlide } from '../services/api';
import {DragOverlay } from '@dnd-kit/core';
import { restrictToWindowEdges } from '@dnd-kit/modifiers';
import {
    Add
} from '@mui/icons-material';
import {Link, LinkEdit, Presentation, Scenario, Slide, Visit} from '../services/types'
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import SlideEditModal from '../components/SlideEditModal'
import { SelectChangeEvent } from '@mui/material/Select';
import LinkEditModal from "./LinkEditModal";

// interface VisitSlide {
//     id: string;
//     slide: Slide;
// }
// interface Visit {
//     id: string;
//     name: string;
//     project_id: string;
//     sort: number;
//     external_id?: string;
//     slides: VisitSlide[];
// }
interface ScenarioEditorProps {
    scenario: Scenario;
    updateScenarioData: (scenario: Scenario) => void;
}
// interface Presentation {
//     id: string;
//     name: string;
//     photo_url: string;
//     clm_type_id: string;
//     // Add other properties as needed
// }

// interface VisitBoxProps {
//     visit: Visit;
//     onAddSlide: (visitId: string) => void;
// }
// interface SortableSlideItemProps {
//     slide: VisitSlide;
// }

function getSlidesIds(data: any): number[] {
    if (!data.slides || !Array.isArray(data.slides)) {
        return [];
    }
    return data.slides.map((slide: any) => slide.id);
}
function getVisitById(list: any[], id: number) {
    return list.find((visit: { id: any; }) => visit.id === id);
}
function getVisitIds(data: any): number[] {
    if (!data.visites || !Array.isArray(data.visites)) {
        return [];
    }
    return data.visites.map((visit: any) => visit.id);
}
function getPresentationById(list: any[], id: string) {
    return list.find((presentation: { id: any; }) => presentation.id === id);
}
const ScenarioEditor: React.FC<ScenarioEditorProps> = ({ scenario, updateScenarioData }) => {
    const fileInputRef = React.useRef<HTMLInputElement>(null);
    const [slides, setSlides] = useState<Slide[]>([]);
    const [visites, setVisits] = useState<Visit[]>([]);
    const [selectAddVisit, setSelectAddVisit] = useState<number>(0);
    const [selectEditNameVisit, setSelectEditNameVisit] = useState<number>(0);
    const [isProcessModalOpen, setProcessModalOpen] = useState(false);
    const [isVisitCreateModalOpen, setIsVisitCreateModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [createVisitName, setCreateVisitName] = useState('');
    const [currentVisitName, setCurrentVisitName] = useState('');
    const [isSlideSelectionModalOpen, setIsSlideSelectionModalOpen] = useState(false);
    const [onSlideSelect, setOnSlideSelect] = useState<(slideId: number) => void>(() => {});
    const [isSlideEditModalOpen, setIsSlideEditModalOpen] = useState(false);
    const [selectedSlide, setSelectedSlide] = useState<Slide | null>(null);
    const [selectedSlideId, setSelectedSlideId] = useState<number>(0);
    const [projectSlides, setProjectSlides] = useState<Slide[]>([]);
    const [projectHotSlides, setProjectHotSlides] = useState<Slide[]>([]);
    const [presentations, setPresentations] = useState<Presentation[]>([]);
    const [selectedPresentation, setSelectedPresentation] = useState<Presentation | null>(null);
    const [selectedPresentationId, setSelectedPresentationId] = useState<string>("");
    const [currentScenario, setCurrentScenario] = useState<Scenario | null>(null);

    const handleSave = async () => {
        try {
            const visitIds = getVisitIds(scenario);
            const updateData = {
                title: currentScenario?.title,
                description: currentScenario?.description,
                pictureId: 1,
                visitesIds: visitIds
            }
            await updateScenario(currentScenario?.id, updateData);
            updateScenarioData(currentScenario!!)
        } catch (error) {
            console.error('Error inviting team member:', error)
        }
    };
    const handleUploadClick = () => {
        fileInputRef.current?.click();
    };

    const fetchSlides = async () => {
        try {
            // const response = await getSlides(scenario.id);
            // setSlides(response.items);
        } catch (error) {
            console.error('Error fetching slides:', error);
        }
    };
    const fetchVisits = async () => {
        try {
            const response = await getVisits(scenario.id);
            setVisits(response.items);
        } catch (error) {
            console.error('Error fetching slides:', error);
            // setVisits([]);
        }
    };
    useEffect(() => {
        fetchSlides();
        fetchVisits();
        loadPresentations();
        setCurrentScenario(scenario)
    }, [scenario.id]);

    const handleCreateVisit = async () => {
        try {
            const addData = {
                title: createVisitName,
                description: "",
                pictureId: 1,
            }
            const response = await addVisit(addData);

            let visitIds = getVisitIds(scenario);
            visitIds.push(response.id)
            const updateData = {
                title: currentScenario?.title,
                description: currentScenario?.description,
                pictureId: 1,
                visitesIds: visitIds
            }
            await updateScenario(currentScenario?.id, updateData);


            setIsVisitCreateModalOpen(false);
            setCreateVisitName('');
            fetchVisits();
            // loadScenarios();
        } catch (error) {
            console.error('Error inviting team member:', error);
        }

    };

    const fetchProjectSlides = async (projectId: string) => {
        try {
            // const response = await getSlides(projectId);
            // setProjectSlides(response.items);
        } catch (error) {
            console.error('Ошибка при получении слайдов проекта:', error);
        }
    };
    const loadPresentations = async () => {
        const data = await fetchPresentations(1, 100);
        setPresentations(data.items);
    };
    const handleProjectChange = (event: SelectChangeEvent<string>) => {
        const projectId = event.target.value;
        setSelectedPresentationId(projectId)
        setSelectedPresentation(getPresentationById(presentations, projectId));
        // fetchProjectSlides(projectId);
    };


    const handleReorderSlides = async (visitId: number, newOrder: number[]) => {
        try {
            const vis: Visit = getVisitById(visites, visitId)
            const updateData = {
                title: vis?.title,
                description: vis?.description,
                pictureId: 1,
                slidesIds: newOrder
            }
            await updateVisit(vis?.id, updateData);
            fetchVisits();
        } catch (error) {
            console.error('Error reordering slides:', error);
        }
    };


    const handleAddSlideModal = async (visitId:number) => {
        setIsSlideSelectionModalOpen(true);
        setSelectAddVisit(visitId)
    };


    const handleEditSlide = async (visitSlideId: number) => {
        console.log(visitSlideId)
        setIsSlideEditModalOpen(true)
        setSelectedSlideId(visitSlideId)
    };
    const handleEditSlideClose = async () => {
        setIsSlideEditModalOpen(false)
        setSelectedSlideId(0)
    };


    const handleDeleteSlide = async (visitId:number, visitSlideId: number) => {
        try {
            const vis: Visit = getVisitById(visites, visitId)
            let slidesOnVisit = getSlidesIds(vis)
            const index = slidesOnVisit.indexOf(visitSlideId);
            if (index > -1) {
                slidesOnVisit.splice(index, 1);
            }
            const updateData = {
                title: vis?.title,
                description: vis?.description,
                pictureId: 1,
                slidesIds: slidesOnVisit
            }
            await updateVisit(vis?.id, updateData);
            fetchVisits();
        } catch (error) {
            console.error('Error deleting slide:', error);
            // Handle error (e.g., show an error message to the user)
        }
    };

    const handleAddSlideToVisit = async (slideId: number) => {
        setIsSlideSelectionModalOpen(false);
        try {
            const vis: Visit = getVisitById(visites, selectAddVisit)
            let slidesOnVisit = getSlidesIds(vis)
            slidesOnVisit.push(slideId)
            const updateData = {
                title: vis?.title,
                description: vis?.description,
                pictureId: 1,
                slidesIds: slidesOnVisit
            }
            await updateVisit(vis?.id, updateData);
            fetchVisits();
        } catch (error) {
            console.error('Error adding slide to visit:', error);
        }
    };
    const handleUpdateSlide = async (updatedSlide: Slide) => {
        try {
            // await updateSlide(updatedSlide.id, {
            //     description: updatedSlide.description,
            //     duration: updatedSlide.duration,
            //     external_id: updatedSlide.external_id,
            // });
            // fetchSlides();
        } catch (error) {
            console.error('Error updating slide:', error);
        }
    };
    const handleDeleteVisit = async (visitId:number) => {
        await  deleteVisit(visitId)
        let visitIds = getVisitIds(scenario);
        const index = visitIds.indexOf(visitId);
        if (index > -1) {
            visitIds.splice(index, 1);
        }
        const updateData = {
            title: currentScenario?.title,
            description: currentScenario?.description,
            pictureId: 1,
            visitesIds: visitIds
        }
        await updateScenario(currentScenario?.id, updateData);

        fetchVisits();
    };
    const handleEditNameModal = async (visitId:number, visitName: string) => {
        setIsEditModalOpen(true);
        setCurrentVisitName(visitName)
        setSelectEditNameVisit(visitId)
    };
    const handleEditVisitName = async () => {
        setIsEditModalOpen(false);
        const vis: Visit = getVisitById(visites, selectEditNameVisit)
        let slidesOnVisit = getSlidesIds(vis)
        const updateData = {
            title: currentVisitName,
            description: vis?.description,
            pictureId: 1,
            slidesIds: slidesOnVisit
        }
        console.log(updateData)
        await updateVisit(vis?.id, updateData);
        fetchVisits();

        // await editVisitName(selectEditNameVisit, currentVisitName);
        // fetchVisits()
    };

    // const handleSlideClick = (slide: Slide) => {
    //     setSelectedSlide(slide as Slide);
    //     setIsSlideEditModalOpen(true);
    // };
    //
    // const handleGenerateClick = async () => {
    //     setProcessModalOpen(true)
    //     await processProject(scenario.id)
    //     setProcessModalOpen(false)
    // };
    // const handleOpenLink = () => {
    //     window.open('https://app.productscript.ru/'+scenario.id+'/', '_blank');
    // };
    //
    // const handleDownloadLink = () => {
    //     window.open('https://static.productscript.ru/uploads/archives/'+scenario.id+'/source.zip', '_blank');
    // };

    return (
        <Box display="flex" sx={{height: 'calc(100vh - 64px)'}}>
            <Box sx={{display: 'flex', flexDirection: 'column', width: '384px', height: '100%', background: '#3a485b36', boxSizing: 'border-box'}}>
                <Box sx={{padding: '10px 20px'}}>
                    <TextField
                        fullWidth
                        margin="normal"
                        label="Название"
                        value={currentScenario?.title}
                        onChange={(e) => {
                            setCurrentScenario({
                                ...currentScenario!!,
                                title: e.target.value
                            });
                        }}
                        multiline
                        rows={1}
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        label="Описание"
                        value={currentScenario?.description}
                        onChange={(e) => {
                            setCurrentScenario({
                                ...currentScenario!!,
                                description: e.target.value
                            });
                        }}
                        multiline
                        rows={4}
                    />
                    <Button onClick={handleSave} variant="contained" sx={{mt: 2, background:'#3a485b', width: '100%'}}>
                        Сохранить
                    </Button>
                </Box>
            </Box>

            <Box sx={{width: 'calc(100% - 384px)', height: 'calc(100% - 64px)', position: 'absolute', right: 0, overflowX: 'hidden', overflowY: 'scroll'}}>
                <Box sx={{width: 'calc(100% - 24px)'}} p={2}>
                    {currentScenario !== null && visites.map((visit) => (
                        <VisitBox
                            key={visit.id}
                            visit={visit}
                            onAddSlide={handleAddSlideModal}
                            onEditName={handleEditNameModal}
                            onDeleteVisit={handleDeleteVisit}
                            onReorderSlides={handleReorderSlides}
                            onDeleteSlide={handleDeleteSlide}
                            onEditSlide={handleEditSlide}
                        />
                    ))}
                    <Box sx={{display: 'flex', justifyContent: 'center'}}>
                        <Button sx={{color: '#3a485b', display: 'flex', gap: '4px'}}
                                onClick={() => setIsVisitCreateModalOpen(true)}><Add/> Добавить визит</Button>
                    </Box>
                </Box>
            </Box>


            {/* Модальное окно создания главы */}
            <Modal open={isVisitCreateModalOpen} onClose={() => setIsVisitCreateModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 600, minWidth: 300 }}>
                        <Typography variant="h6">Добавить визит</Typography>
                        <TextField
                            label="Название"
                            value={createVisitName}
                            onChange={(e) => setCreateVisitName(e.target.value)}
                            fullWidth
                            type="text"
                            margin="normal"
                        />
                        <Box sx={{display:'flex', justifyContent: 'space-between', mt: 2, gap: 2}}>
                            <Button className="blueModalButton" variant="contained" onClick={handleCreateVisit}>
                                Добавить
                            </Button>
                            <Button className="blueModalButton" variant="outlined" onClick={()=>setIsVisitCreateModalOpen(false)} style={{color: 'red', borderColor: 'red'}}>
                                Отмена
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            {/* Модальное окно создания главы */}
            <Modal open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 600, minWidth: 300 }}>
                        <Typography variant="h6">Редактировать название</Typography>
                        <TextField
                            label="Название"
                            value={currentVisitName}
                            onChange={(e) => setCurrentVisitName(e.target.value)}
                            fullWidth
                            type="text"
                            margin="normal"
                        />
                        <Box sx={{display:'flex', justifyContent: 'space-between', mt: 2, gap: 2}}>
                            <Button className="blueModalButton" variant="contained" onClick={handleEditVisitName}>
                                Сохранить
                            </Button>
                            <Button className="blueModalButton" variant="outlined" onClick={()=>setIsEditModalOpen(false)} style={{color: 'red', borderColor: 'red'}}>
                                Отмена
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            {/* Модальное окно выбора слайда */}

            <Modal open={isSlideSelectionModalOpen} onClose={() => setIsSlideSelectionModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center', overflowY: 'scroll'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 600, minWidth: 300, maxHeight:'90vh', overflow: 'scroll' }}>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label">Выберите презентацию</InputLabel>
                            <Select
                                labelId="project-select-label"
                                id="project-select"
                                value={selectedPresentationId}
                                label="Выберите презентацию"
                                onChange={handleProjectChange}
                            >
                                {presentations.map((presentation) => (
                                    <MenuItem key={presentation.id} value={presentation.id}>
                                        {presentation.title}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        {selectedPresentation !== null && (
                            <Box className='addModalSlideItems'>
                                {selectedPresentation!!.slides.map((slide) => (
                                    <Box className='addModalSlideItem' key={slide.id} onClick={() => handleAddSlideToVisit(slide.id)}>
                                        <img src={'https://stage.selfdetailing.ru'+slide.picture.raw} alt={slide.picture.raw} style={{maxHeight: '256px', objectFit:'cover', width:'100%'}}/>
                                    </Box>
                                ))}
                            </Box>
                        )}


                        <Box sx={{display:'flex', justifyContent: 'space-between', mt: 2, gap: 2}}>
                            <Box></Box>
                            <Button className="blueModalButton" variant="outlined" onClick={() => setIsSlideSelectionModalOpen(false)} style={{color: 'red', borderColor: 'red'}}>
                                Отмена
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>


            <Modal open={isProcessModalOpen}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 600 }}>
                        <Box sx={{ /* стили */ }}>
                            <Typography sx={{mb: 3}}>Идет обработка</Typography>
                            <Box sx={{display: 'flex', justifyContent: 'center'}}>
                                <CircularProgress style={{color: '#3a485b'}}/>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Modal>


            <Modal open={isSlideEditModalOpen}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, padding: 0, width: 'calc(100vw - 180px)', height: 'calc(100vh - 180px)', overflow: 'hidden' }}>
                        <SlideEditModal slideId={selectedSlideId} onClose={handleEditSlideClose}></SlideEditModal>
                    </Box>
                </Box>
            </Modal>


        </Box>
    );
};
export default ScenarioEditor;
